import { Box, InputBase, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { postUserSigninForm2 } from "../../api/signin";
import AccessibilityIcon from "../../assets/SVG/accessibilityIcon";
import AllergyIcon from "../../assets/SVG/allergyIcon";
import BloodType from "../../assets/SVG/bloodType";
import MaskIcon from "../../assets/SVG/maskIcon";
import ProfileIcon from "../../assets/SVG/profileIcon";
import Vector from "../../assets/SVG/vector";
import SelectInput from "./selectInput";

export default function SigninFormMujahid2({
  setLevel,
  setDataForm,
  dataForm,
  dataFormFinal,
  setDataFormFinal,
  update,
}) {
  const [bloodType, setBloodType] = useState(0);
  const [bloodTypeFinal, setBloodTypeFinal] = useState();
  const styleLabel = {
    color: "#2B2B2B",
    textAlign: "right",
    fontSize: "16px",
    fontWeight: "600",
  };
  useEffect(() => {
    if (bloodType === "A+") setBloodTypeFinal("A_PLUS");
    if (bloodType === "A-") setBloodTypeFinal("A_MINUS");
    if (bloodType === "B+") setBloodTypeFinal("B_PLUS");
    if (bloodType === "B-") setBloodTypeFinal("B_MINUS");
    if (bloodType === "AB-") setBloodTypeFinal("AB_MINUS");
    if (bloodType === "AB+") setBloodTypeFinal("AB_PLUS");
    if (bloodType === "O+") setBloodTypeFinal("O_PLUS");
    if (bloodType === "O-") setBloodTypeFinal("O_MINUS");
  }, [bloodType]);
  useEffect(() => {
    if (bloodType) {
      setDataForm({ ...dataForm, bloodType: bloodTypeFinal });
      setDataFormFinal({ ...dataFormFinal, bloodType: bloodTypeFinal });
    }
  }, [bloodTypeFinal]);
  useEffect(() => {
    if (dataFormFinal.bloodType === "A_PLUS") setBloodType("A+");
    if (dataFormFinal.bloodType === "A_MINUS") setBloodType("A-");
    if (dataFormFinal.bloodType === "B_PLUS") setBloodType("B+");
    if (dataFormFinal.bloodType === "B_MINUS") setBloodType("B-");
    if (dataFormFinal.bloodType === "AB_MINUS") setBloodType("AB-");
    if (dataFormFinal.bloodType === "AB_PLUS") setBloodType("AB+");
    if (dataFormFinal.bloodType === "O_PLUS") setBloodType("O+");
    if (dataFormFinal.bloodType === "O_MINUS") setBloodType("O-");
  }, [dataFormFinal]);
  return (
    <Box mt="20px" width="380px">
      <Typography mt="10px" sx={styleLabel}>
        {"مهارت ها"}
      </Typography>
      <Box
        sx={{
          border: "solid 1px var(--emr-borderInput)",
          borderRadius: "8px",
          px: "10px",
          py: "5px",
          height: "110px",
          display: "flex",
          mt: "5px",
          boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          //   alignItems: "center",
          gap: "10px",
        }}
      >
        <AccessibilityIcon />
        <InputBase
          onChange={(e) => {
            setDataForm({ ...dataForm, abilities: e.target.value });
            setDataFormFinal({ ...dataFormFinal, abilities: e.target.value });
          }}
          value={dataForm.abilities}
          multiline
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "start",
            overflow: "hidden",
          }}
          placeholder="اگر در زمینه فیلم‌برداری، عکس‌برداری، کار با نرم‌افزارهای گرافیکی، طراحی و ساخت کلیپ تمایل به همکاری دارید، لطفا زمینه‌ی فعالیت و توضیحات مربوطه را مرقوم فرمائید."
        />
      </Box>
      <Typography mt="10px" sx={styleLabel}>
        {"بیماری"}
      </Typography>
      <Box
        sx={{
          border: "solid 1px var(--emr-borderInput)",
          borderRadius: "8px",
          px: "10px",
          py: "5px",
          height: "150px",
          display: "flex",
          mt: "5px",
          boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          //   alignItems: "center",
          gap: "10px",
        }}
      >
        <MaskIcon />
        <InputBase
          onChange={(e) => {
            setDataForm({ ...dataForm, diseases: e.target.value });
            setDataFormFinal({ ...dataFormFinal, diseases: e.target.value });
          }}
          value={dataForm.diseases}
          multiline
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "start",
            overflow: "hidden",
          }}
          placeholder="در صورت داشتن هرگونه بیماری با امکان ایجاد تظاهرات حاد (از قبیل مشکلات قلبی-ریوی، نورولوژیک و ...) و یا نیاز به مصرف دارویی به صورت مزمن ( مانند انسولین و دارو‌های مرتبط با قندخون، داروهای قلبی، اسپری‌های ریوی و ...) آن را ذکر کنید."
        />
      </Box>
      <Typography mt="10px" sx={styleLabel}>
        {"حساسیت ها"}
      </Typography>
      <Box
        sx={{
          border: "solid 1px var(--emr-borderInput)",
          borderRadius: "8px",
          px: "10px",
          py: "5px",
          height: "60px",
          display: "flex",
          mt: "5px",
          boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          //   alignItems: "center",
          gap: "10px",
        }}
      >
        <AllergyIcon />
        <InputBase
          onChange={(e) => {
            setDataForm({ ...dataForm, allergies: e.target.value });
            setDataFormFinal({ ...dataFormFinal, allergies: e.target.value });
          }}
          value={dataForm.allergies}
          multiline
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "start",
            overflow: "hidden",
          }}
          placeholder="در صورت داشتن هرگونه حساسیت دارویی و غذایی، آن را ذکر کنید."
        />
      </Box>
      <Typography mt="10px" sx={styleLabel} display="flex">
        {"گروه خونی"}
        <Typography color="red" mr="5px">
          *
        </Typography>
      </Typography>
      {/* <Box
        sx={{
          border: "solid 1px var(--emr-borderInput)",
          borderRadius: "8px",
          px: "10px",
          height: "50px",
          display: "flex",
          mt: "5px",
          boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <BloodType />
        <InputBase
        value={dataForm.bloodType}
          onChange={(e) =>
            setDataForm({ ...dataForm, bloodType: e.target.value })
          }
          placeholder="گروه خونی خود را وارد کنید."
        />
      </Box> */}
      <SelectInput
        value={bloodType}
        setValue={setBloodType}
        width="380px"
        data={["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"]}
        placeholder="گروه خونی خود را انتخاب کنید."
      />
      <Box display="flex" justifyContent="end">
        {/* <button
          style={{
            border: "none",
            width: "150px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
            // boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            padding: "12px 0px",
            marginTop: "20px",
            borderRadius: "8px",
          }}
          onClick={() => setLevel(1)}
        >
          <Box sx={{ transform: "rotate(180deg)", mt: "-4px" }}>
            <Vector color="#E24B4B" />
          </Box>
          <Typography
            fontWeight={"bold"}
            fontSize="16px"
            color="#E24B4B"
            mr="10px"
          >
            مرحله قبل
          </Typography>
        </button> */}
        <button
          style={{
            border: "none",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#6CBBC7",
            boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            padding: "12px 0px",
            marginTop: "20px",
            borderRadius: "8px",
          }}
          onClick={() => {
            if (update) {
              setLevel(3);
            } else {
              if (dataFormFinal.bloodType) {
                postUserSigninForm2(dataForm)
                  .then(() => {
                    setLevel(3);
                  })
                  .catch((err) => console.log(err));
              } else {
                toast.error("فیلد های ضروری را پر کنید");
              }
            }
          }}
        >
          <Typography fontSize="16px" color="white" ml="10px">
            مرحله بعد
          </Typography>
          <Vector color="white" />
        </button>
      </Box>
    </Box>
  );
}
